<template>
  <div>
    <app-base-main>
      <template #table>
        <gj-table
          name="inventoryConfig"
          :data="tableData"
          :columns="columns"
          :show-overflow="false"
          :show-pagination="false">
          <template v-slot:configId="{ index, row }">
            <template v-if="row.quota === '滞销库龄区间'">
              <gj-select
                  :value="row.configId"
                  multiple
                  collapse-tags
                  :options="[
                    {id: 0, text: '0-90天库龄'},
                    {id: 1, text: '91-180天库龄'},
                    {id: 2, text: '181-270天库龄'},
                    {id: 3, text: '271-365天库龄'},
                    {id: 4, text: '365天以上库龄'}
                  ]"
                  :clearable="false"
                  width="200px"
                  @input="changeConfig($event)"
              ></gj-select>
            </template>
          </template>
        </gj-table>
      </template>
    </app-base-main>
  </div>
</template>

<script>
  export default {
    name: "app-inventory-configuration",
    data() {
      return {
        tableData: [
          {
            quota: '滞销库龄区间',
            configId: 1,
            desc: '根据库龄天数判断库存是否滞销，系统将根据配置项设置的库龄天数的库存，计入滞销库存',
            updateDate: '2020.01.12 13:30:30',
          }
        ],
        columns: [
          {id: 'quota', header: '库存指标', field: 'quota', minWidth: '200px'},
          {id: 'configId', header: '配置项', field: 'slot:configId', minWidth: '200px'},
          {id: 'desc', header: '指标配置说明', field: 'desc', minWidth: '400px'},
          {id: 'updateDate', header: '更新时间', field: 'updateDate', width: '200px'},
        ],
      }
    },
    methods: {
      changeConfig(configId) {
      }
    }
  }
</script>

<style scoped>

</style>
